import { ActionLabel } from '../../../data';

import NavigateIcon from '../../../../../../assets/icons/redirect.svg?react';

export const AIFMJurisdictionColumn = ({ period }) => {
  return (
    <ActionLabel
      style={{ width: 150 }}
      label={`${period.jurisdiction_count} jurisdictions`}
      color="#40C057"
      rightIcon={<NavigateIcon />}
    />
  );
};
